export default __webpack_public_path__ + "static/thumb-plan-video-d9bdec564106eefa7422381495cb8142.png";